import React, {useCallback, useState} from "react";
import {useAdmin} from "../../../contexts/AdminContext";
import {Login} from "../../../types/Subscription";
import Heading from "../../../components/Heading";
import Text from "../../../components/Text";
import Button from "../../../components/Button";
import {faArrowLeft} from "@fortawesome/free-solid-svg-icons";
import IconButton from "../../../components/IconButton";
import LoginForm from "../Forms/LoginForm";
import {useTranslation} from "react-i18next";
import {useGlobalContext} from "../../../contexts/globalContext";


const SubscriptionLogin: React.FC<{changePage: (p: string) => void}> = ({changePage}) => {
    const { service, changeUser } = useAdmin()
    const [data, setData] = useState<Partial<Login>>({})
    const {t} = useTranslation(['settings'])
    const {showToast} = useGlobalContext()

    const changeData = useCallback((data: Partial<Login>) => {
        setData(prevElement => ({...prevElement, ...data}))
    }, [])

    const submit = useCallback(() => {
        service.login(data).then((res) => {
            service.setToken('Bearer ' + res.data.access_token)
            changeUser(res.data.user)
            changePage("overview")
        }).catch(() => {
            showToast('top-right', 'error', t('subscription.loginError'))
        })
    }, [service, data, changePage, changeUser, showToast, t])

    return (
        <div className={'mt-3'}>
            <Heading level={3} classes={'mb-4'}>{t("subscription.logInToYourAccount")}</Heading>
            <IconButton
                icon={faArrowLeft}
                color={'black'}
                onClick={() => changePage('overview')}
            >
                {t("subscription.back")}
            </IconButton>
            <Text classes={'mt-3'}>{t("subscription.inCaseOfNoAccount")}</Text>
            <LoginForm data={data} changeData={changeData}/>
            <div className={'mt-4 d-flex justify-content-between'}>
                <Button hierarchy={'tertiary'} text={t("subscription.forgotPassword")} fn={() => changePage('password_reset')}/>
                <Button fn={() => submit()} hierarchy={'primary'} text={t("subscription.login")}/>
            </div>
        </div>
    )
}

export default SubscriptionLogin
